export function handleAlert(message, type, fixed, timeout) {
  this.$root.$emit("alert", { message, type, fixed, timeout });
}

export function handleFinishAttendance() {
  this.$root.$emit("attendance:finish");
}

export function showError(error) {
  const message =
    error?.response?.data?.message ||
    error?.data?.message ||
    error?.message ||
    error;
  this.$root.$emit("alert", { message, error });
}

export function formatDocument(value) {
  if (!value) return;

  if (value.length === 11)
    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");

  if (value.length === 14)
    return value.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
      "$1.$2.$3/$4-$5"
    );

  return value;
}

export function fetchTotalPages(total, limit = 15) {
  let value = total / limit;
  if (value % 1 !== 0) value = value + 1;

  return Math.trunc(value);
}

export function validateCpf(cpf) {
  cpf = cpf.replace(/\D/g, "");
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

  const calcDigito = (fator) =>
    ((cpf
      .slice(0, fator - 1)
      .split("")
      .reduce((soma, num, i) => soma + num * (fator - i), 0) *
      10) %
      11) %
    10;

  return calcDigito(10) == cpf[9] && calcDigito(11) == cpf[10];
}

// Desde a mudança da Receita Federal para CNPJ alfanumérico, as 12 primeiras
// posições podem ser letra ou número — só os 2 dígitos verificadores finais
// continuam numéricos. O valor de cada caractere é `charCode - 48` (dígitos
// '0'-'9' viram 0-9, letras 'A'-'Z' viram 17-42), conforme o algoritmo oficial.
export function validateCnpj(cnpj) {
  cnpj = cnpj.replace(/[^0-9A-Za-z]/g, "").toUpperCase();
  if (cnpj.length !== 14 || /^(.)\1{13}$/.test(cnpj)) return false;

  const charValue = (char) => char.charCodeAt(0) - 48;

  const calcDigito = (length) => {
    const numbers = cnpj.substring(0, length);
    let sum = 0;
    let pos = length - 7;

    for (let i = 0; i < length; i += 1) {
      sum += charValue(numbers[i]) * pos;
      pos = pos > 2 ? pos - 1 : 9;
    }

    return sum % 11 < 2 ? 0 : 11 - (sum % 11);
  };

  return calcDigito(12) == cnpj[12] && calcDigito(13) == cnpj[13];
}

// A OAB não possui dígito verificador oficial nacional — valida apenas o
// formato: número de inscrição (3 a 6 dígitos) seguido da seccional (UF).
export function validateOab(oab) {
  oab = oab.replace(/[^\dA-Za-z/]+/g, "").toUpperCase();

  return /^\d{3,6}\/[A-Z]{2}$/.test(oab);
}
